export const assessmentResultShortText = {
  CD: 'CĐ',
  D: 'Đ',
  K: 'K',
  T: 'T',
};
